import React , { useEffect , useState, useMemo} from 'react';
import '../styling/containerStyles.css'
import Label from '../components/label'
import TransactionHistory from '../transactionHistory';
import crossIcon from '../assets/images/crossIcon.svg';
import checkIcon from '../assets/images/checkIcon.png';
import pendingIcon from '../assets/images/pendingIcon.png';
import WarningModal from '../components/modal';
import ReactPlayer from "react-player";
import { Box, IconButton, Modal } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { phoneIcon as PhoneIcon } from './../assets/icons/phoneIcon';


interface SuccessTransactionProps{
    handleToUpdateTransactionOK:Function;
    paymentStatus:string;
    paymentMessage:string;
    transactions:any;
    transactionLoading: boolean;
    amount:string;
    isZero :any;
    memberId : any;
    handleGetLocationData : Function;
    handleUpdateIsZeroStatus : Function
    coupons: Array<{ code: string; amount: string }>;
    multiScanResults?: Array<{ coupon: string; status: string; message: string, orderId?: string, razor_transaction_id?: string, amount?: string }>;
}

export const SuccessTransaction: React.FC<SuccessTransactionProps> = (props: SuccessTransactionProps) =>{

    const{
    handleToUpdateTransactionOK, paymentStatus, transactions, paymentMessage, transactionLoading, amount , isZero  , memberId , handleGetLocationData , handleUpdateIsZeroStatus, coupons, multiScanResults = []
    } = props;
    const isMultiScan = coupons.length > 0;
    const mergedTransactions = useMemo(() => {
        if (!transactions || !Array.isArray(transactions) || transactions.length === 0) {
            if (multiScanResults && multiScanResults.length > 0) {
                return multiScanResults.map(r => ({
                    coupon_code: r.coupon,
                    redeem_amount: r.orderId === "-" ? r.message : `&#x20b9;${r.amount || '0'}`,
                    status: r.status,
                }));
            }
            return transactions;
        }
        const baseArray = transactions;

        const couponSetFromBackend = new Set(
          (baseArray as any[]).map((t: any) => t.coupon_code || t.coupon || '')
        );

        const syntheticRows =
          multiScanResults && multiScanResults.length > 0
            ? multiScanResults
                .filter(r => {
                  const inBackend = couponSetFromBackend.has(r.coupon);
                  const hasRealOrder = r.orderId && r.orderId !== '-';
                  return !(inBackend && hasRealOrder);
                })
                .map(r => ({
                  coupon_code: r.coupon,
                  redeem_amount: r.message || '',
                  status: r.status,
                }))
            : [];

        return [...syntheticRows, ...baseArray];
    }, [transactions, multiScanResults]);

    const [locationBlocked, setLocationBlocked] = useState(false)
    const [openVideoModal, setVideoModal] = useState(false)

    
    const heading = "Location Disabled !!"
    const content = "Please allow location services"


    useEffect(() => {
        if (paymentStatus === 'PENDING' && coupons.length === 0) {
            handleToUpdateTransactionOK('PENDING');
        }
    }, [paymentStatus, handleToUpdateTransactionOK, coupons.length]);

    useEffect(() => {
        navigator.permissions.query({
            name: 'geolocation'
        }).then(function(result) {
            if (result.state === 'denied') {
                setLocationBlocked(true)
            }else{
                if(isZero == "Yes"){
                    handleUpdateIsZeroStatus()     
                   if(memberId){
                        navigator.geolocation.getCurrentPosition((pos) => {
                            var geocoder = new google.maps.Geocoder();
                                var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                                geocoder.geocode({ 'location': latlng }, function (results, status) {
                                    if (status === google.maps.GeocoderStatus.OK && results[0]) {
                                            var pincode= "";
                                            var city = "";
                                            for (var j = 0; j < results[0].address_components.length; j++) {
                                              if (results[0].address_components[j].types[0] === 'postal_code') {
                                                  pincode = results[0].address_components[j].long_name
                                              }
                                              if (results[0].address_components[j].types[0] === 'locality') {
                                                  city = results[0].address_components[j].long_name
                                              }
                                            }      
                                                       
                                            handleGetLocationData(
                                              city,
                                              pincode,
                                              pos.coords.latitude,
                                              pos.coords.longitude,
                                              memberId
                                            )
                                    }
                                })
                          }) 
                    }
                }
            }
        });
     
                
    }, [memberId])
    

    const openModal = () => {
        setVideoModal(true)
    };

    const closeModal = () => {
        setVideoModal(false)
    };

    return (
    <div className={paymentStatus==='FAILURE' || paymentStatus==='SUCCESS' || paymentStatus==='PENDING' || isZero == "Yes" ? 'suc' : 'suc failur-box-wrapper'} id="cust box">
        {
                            locationBlocked && <WarningModal heading={heading} content={content} />
                        }
        {paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'RESPONSE_MESSAGE' &&
        <>
        {/* <div className='buttonAndLabel'>
            <Button className='goBack' onClick={()=> {handleToUpdateBankDetails('GoBack')}} >
                <ClearIcon /></Button>
                <Label content='Transaction Details' />
        </div>
        <br></br> */}
        </>
        }

        {paymentStatus==='NOT POSSIBLE' &&
        paymentMessage === "You are a registered customer of Pidilite" ?
        <div className='no_transaction'>
            <h1>{paymentMessage}</h1>
        </div>
        :
        paymentStatus==='NOT POSSIBLE' &&
        paymentMessage !== "You are a registered customer of Pidilite" &&
        <div className='no_transaction'>
            <h1>Oops !!</h1>
            Transaction cannot be processed
            <br />
            {paymentMessage}
        </div>
        }

        {/* If amount is greater than 500 then restrict */}
        {paymentStatus==='AMOUNTINVALID' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {/* 1 user can redeem 10 coupons per day */}
        {paymentStatus==='MEMBERINVALID' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {/* Block user if user use 5 invalid coupons */}
        {paymentStatus==='BLOCKUSER' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {paymentStatus==='PENDING_MESSAGE' &&
        <div className='failure_transaction'>
            {/* <h1>Transaction Failed</h1> */}
            {paymentMessage}
        </div>
        }

        {isMultiScan && (
          <div className='success_transaction transition_main_wrap completed-transaction'>
            <div className='homeWrap'>
              <div className='homeTop'>
                <div className='homeTopInner'>
                  <div className='buttonAndLabel withoutTopLabel'>
                    <p>Transaction Details</p>
                  </div>
                  <img src={checkIcon} alt='Cross Icon' className='checkIcon'/>
                  <p className='transitionStatus'>Transaction Completed</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {paymentStatus==='SUCCESS' && coupons.length === 0 &&
        <div className='success_transaction transition_main_wrap completed-transaction'>
            {/* <h1>Success !!</h1>
            This transaction was successful */}
            <div className='homeWrap'>
                <div className='homeTop'>
                    <div className='homeTopInner'>
                        <div className='buttonAndLabel withoutTopLabel'>
                            <p>Transaction Details</p>
                        </div>
                        <img src={checkIcon} alt='Cross Icon' className='checkIcon'/>
                        <p className='transitionStatus'>Transaction Successful</p>
                        <p className='transitionSubtile'>This transaction was successful</p>
                        <p className='creditValue'>Credited : &#x20b9;{amount}</p>
                    </div>
                </div>
            </div>
        </div>
        }
        
        {!locationBlocked &&  isZero==='Yes' &&
          <div className='success_transaction zero-val' style={{ marginTop : "5rem"}} >
          <h1>Success !!</h1>
          Thank you for registering your purchase! Please connect with Pidilite executive to know more about exciting offers.
          <div className='zeroval-messag'>Connect with our Customer Support Team: 
          <div className='contact-info-zero-val'><a href="tel:2268671495">
          <PhoneIcon color='#ffffff' />2268671495</a></div></div> <br /> 
          <div className="video-text" onClick={() => openModal()}>Watch the all New Woodlok Pro Advertisement here</div>

          <Modal
                open={openVideoModal === true}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="video-image-modal"
            >
                <Box className='modalContentContainer'>
                    <div className='closeIconContainer'>
                        <IconButton onClick={closeModal}
                         >
                            <CloseIcon />
                        </IconButton>
                    </div>
                        <ReactPlayer
                            width="100%"
                            height="100%"
                            url="https://youtu.be/qjhWpQpMn2A"
                            controls={true}
                            className="zero-val-video"
                        />                    
                </Box>
            </Modal>
          <br />
      </div>
        }
        {paymentStatus==='FAILURE' && coupons.length === 0 &&
        <div className='failure_transaction transition_main_wrap'>
            {/* <h1>Failed !!</h1>
            {paymentMessage} */}
            <div className='homeWrap'>
                <div className='homeTop'>
                    <div className='homeTopInner'>
                        <div className='buttonAndLabel withoutTopLabel'>
                            <p>Transaction Details</p>
                        </div>
                        <img src={crossIcon} alt='Cross Icon' className='crossIcon'/>
                        <p className='transitionStatus'>Failed !!</p>
                        <p className='transitionSubtile'>{paymentMessage}</p>
                        {/* <p className='creditValue'>Credited : &#x20b9;{amount}</p> */}
                    </div>
                </div>
            </div>
        </div>
        }
        {paymentStatus==='PENDING' && coupons.length === 0 &&
        <div className='pending_transaction transition_main_wrap'>
            {/* <h1>Pending !!</h1>
            Do not close this window till the transaction is complete */}
            
            <div className='homeWrap'>
                <div className='homeTop'>
                    <div className='homeTopInner'>
                        <div className='buttonAndLabel withoutTopLabel'>
                            <p>Transaction Details</p>
                        </div>
                        <img src={pendingIcon} alt='Pending Icon' className='pendingIcon'/>
                        <p className='transitionStatus'>Pending !!</p>
                        <p className='transitionSubtile'>Do not close this window till the transaction is complete</p>
                        {/* <p className='creditValue'>Credited : &#x20b9;{amount}</p> */}
                    </div>
                </div>
            </div>
        </div>
        }
        {paymentStatus==='RESPONSE_MESSAGE' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {
        paymentStatus !== 'NOT POSSIBLE' && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'RESPONSE_MESSAGE' &&

        <div className={paymentStatus==='FAILURE' ? 'success_transaction_listing tranFailure' : paymentStatus==='PENDING' ? 'success_transaction_listing transPending' : 'success_transaction_listing'}>
            {/* <hr>
            </hr> */}

            {/* <div className='briefing'>
                <div className='leftBox'>
                    <Label content="Transaction History" />
                    <div className='subtext'>Your Transaction History</div>
                </div>

            </div> */}
            {/* <hr>
            </hr> */}

            {/* <div className='buttonAndLabel withToplabel'>
                <Label content='Account History' />
                <div className='sideText'>Your already used bank account details</div>   
            </div> */}


            {/* <div className='transactions history_scroll'>
                {

                <FixedSizeList className="List" height={(window.innerWidth)> 340? 230 : 180}
                    itemData={transactions}
                    itemCount={transactions?.length}//transactions.length
                    itemSize={10}
                    width={(window.innerWidth) > 480?
                    window.innerWidth / 4 : window.innerWidth } >
                    {Row}
                </FixedSizeList>
                }

                <TransactionHistory transactions={transactions} transactionLoading={transactionLoading} />
            </div> */}
            <div className='accountHistory account-history-wrapper'>
                <div className='buttonAndLabel withToplabel'>
                    <Label content='Transaction History' />
                    <div className='sideText'>Your Transaction History</div>   
                </div>

                <TransactionHistory
                  transactions={mergedTransactions}
                  transactionLoading={transactionLoading}
                  isZero={isZero}
                  ismultiScan={coupons.length > 0}
                />
            </div>
        </div>
        }
    </div>
    )
    }


    export default SuccessTransaction